import React from 'react';

/**
 * PageHeader Component - Removed since we now have TabBar navigation
 * Keeping as empty component to avoid breaking existing imports
 */
const PageHeader = ({ t }) => {
  return null;
};

export default PageHeader;
